/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import Vue from 'vue';
import moment from 'moment';
import vuetify from '@/plugins/vuetify';

const envLanguage = process.env.VUE_APP_LANGUAGE;
const defaultLanguage = 'ru';

const state = {
  configsLanguage: null,
  userLanguage: null,
  sessionLanguage: null,
};

const actions = {
  changeLanguage({ commit }, arg) {
    const language = arg;

    Vue.i18n.set(language);
    moment.locale(language);
    vuetify.framework.lang.current = language;
  },
};

const mutations = {
  setConfigsLanguage(state, data) {
    state.configsLanguage = data.toLowerCase();
  },
  setUserLanguage(state, data) {
    state.userLanguage = data.toLowerCase();
  },
  setSessionLanguage(state, data) {
    state.sessionLanguage = data?.toLowerCase() ?? '';
  },
};

const getters = {
  getCurrentLanguage(state) {
    return (
      state.userLanguage ||
      state.sessionLanguage ||
      state.configsLanguage ||
      envLanguage ||
      defaultLanguage
    );
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
